var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AnchorInput',{attrs:{"options":_vm.options}}),_vm._v(" "),_c('MarginInput',{attrs:{"options":_vm.options}}),_vm._v(" "),_c('ColorsInput',{attrs:{"label":"Achtergrondkleur","instruction":"Bepaal hier de achtergrondkleur van het gehele blok.","colors":_vm.colors,"options":_vm.options,"options-property":"color"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }